import React from 'react';
import Button, {ButtonProps} from "@mui/material/Button";
import {ForwardRouterLink} from "./PWMLink";

export const PWMButtonLink: React.FC<IPWMButtonsProps> = (props) => {
  const { children, ...rest} = props;
  
  return (
    <Button component={ForwardRouterLink} {...rest}>{children}</Button>
  )
};

interface IPWMButtonsProps extends Pick<ButtonProps, 'variant' | 'color' | 'startIcon'> {
  children?: React.ReactNode;
  href?: string;
}

export const ButtonOutlined: React.FC<IButtonDefaultProps> = (props) => {
  const {children, ...rest} = props;
  return <Button
    color="inherit"
    size="small"
    variant="outlined"
    {...rest}
  >
    {children}
  </Button>
}

export const ButtonDefault: React.FC<IButtonDefaultProps> = (props) => {
  const {children, ...rest} = props;
  return <Button
    color="inherit"
    size="small"
    {...rest}
  >
    {children}
  </Button>
}

export const ButtonSecondary: React.FC<IButtonDefaultProps> = (props) => {
  const {children, ...rest} = props;
  return <Button
    color="primary"
    size="small"
    {...rest}
  >
    {children}
  </Button>
}

interface IButtonDefaultProps extends ButtonProps {

}